export default __webpack_public_path__ + "static/media/git-icon.c60b7e5a.svg";